import { render, staticRenderFns } from "./CustomerPicture.vue?vue&type=template&id=f12e5330&lang=pug&"
import script from "./CustomerPicture.vue?vue&type=script&lang=js&"
export * from "./CustomerPicture.vue?vue&type=script&lang=js&"
import style0 from "./CustomerPicture.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports